export const treemapUstatPostgraduates = {
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "padding": 10,
  "title": {
    "offset": 30
  },
  "signals": [
    { "name": "organization", 
      "value": null
    },
    {
      "name": "width",
      "value": "",
      "on": [
        {
          "events": {"source": "window", "type": "resize"},
          "update": "containerSize()[0]*0.95"
        }
      ]
    },
    {
      "name": "height",
      "value": "",
      "on": [
        {
          "events": {"source": "window", "type": "resize"},
          "update": "containerSize()[1]*0.95"
        }
      ]
    }
  ],
  "data": [
    {
      "name": "tree",
      "values": null,
      "transform": [
        {
          "type": "nest",
          "generate": true,
          "keys": ["organizationName", "courseName"]
        },
        {
          "type": "treemap",
          "field": "total",
          "sort": {"field": "value", "order": "descending"},
          "method": "squarify",
          "ratio": 2,
          "paddingInner": 0,
          "paddingOuter": 0,
          "size": [{"signal": "width"}, {"signal": "height"}]
        }
      ]
    },
    {
      "name": "nodes",
      "source": "tree",
      "transform": [
        {
          "type": "filter", 
          "expr": "organization === null"
        },
        {
          "type": "filter",
          "expr": "datum.children && datum.depth === 1"
        },
        {
          "type": "extent",
          "field": "children",
          "signal": "extent"
        } 
      ]
    },
    {
      "name": "leaves",
      "source": "tree",
      "transform": [
        {
          "type": "filter", 
          "expr": "organization !== null"
        },
        {
          "type": "filter", 
          "expr": "!datum.children"
        }
      ]
    },
    {
      "name": "total_nodes",
      "source": "nodes",
      "transform": [
        {
          "type": "aggregate",
          "fields": ["children"],
          "ops": ["sum"],
          "as": ["total_nodes"]
        }
      ]
    },
    {
      "name": "total_leaves",
      "source": "leaves",
      "transform": [
        {
          "type": "aggregate",
          "fields": ["total"],
          "ops": ["sum"],
          "as": ["total_leaves"]
        }
      ]
    }
  ],
  "scales": [
    {
      "name": "color",
      "type": "linear",
      "domain": {"data": "nodes", "field": "children"},
      "range": ["#330000", "#CC0000"]
    },
    {
      "name": "colorleaves",
      "type": "linear",
      "domain": {"data": "leaves", "field": "total"},
      "range": ["#330000", "#CC0000"]
    },
    {
      "name": "size",
      "type": "ordinal",
      "domain": [0, 1, 2, 3],
      "range": [256, 28, 20, 14]
    },
    {
      "name": "fontsize",
      "type": "quantize",
      "domain": {"signal": "extent"},
      "range": [0, 16, 24, 34, 46, 60]
    },
    {
      "name": "fontsizeleaves",
      "type": "quantize",
      "domain": {
        "data": "leaves",
        "field": "total"
      },
      "range": [0, 0, 9, 10, 11, 12, 14]
    }
  ],
  "marks": [
    {
      "type": "rect",
      "name": "rect-leaves",
      "from": {"data": "leaves"},
      "interactive": true,
      "encode": {
        "enter": {
          "stroke": { "value": "white"},
          "strokeWidth": { "value": 1}
        },
        "update": {
          "x": {"field": "x0"},
          "y": {"field": "y0"},
          "x2": {"field": "x1"},
          "y2": {"field": "y1"},
          "fill": {
            "scale": "colorleaves",
            "field": "total"
          }
        },
        "hover": {
          "tooltip": {"signal": "datum.courseName + ' ' + format(datum.total / data('total_leaves')[0]['total_leaves'], '.2%')"}
        }
      },      
    },
    {
      "type": "rect",
      "name": "rect-nodes",
      "from": {"data": "nodes"},
      "interactive": true,
      "encode": {
        "enter": {
          "stroke": { "value": "white"},
          "strokeWidth": { "value": 1}
        },
        "update": {
          "fill": {
            "scale": "color", 
            "field": "children"
          },
          "x": {"field": "x0"},
          "y": {"field": "y0"},
          "x2": {"field": "x1"},
          "y2": {"field": "y1"}
        },
        "hover": {
          "tooltip": {
            "signal": "datum.key + ' ' + format(datum.children / data('total_nodes')[0]['total_nodes'], '.2%')"
          }
        }
      }
    },
    {
      "type": "text",
      "clip": true,
      "name": "text-nodes",
      "from": {"data": "nodes"},
      "interactive": false,
      "encode": {
        "enter": {
          "align": {"value": "left"},
          "baseline": {"value": "line-top"},
          "fill": {"value": "#FFF"},
          "opacity": {
            "value": 0.7
          }
        },
        "update": {
          "text": {
            "signal": "datum.key + ' ' + format(datum.children / data('total_nodes')[0]['total_nodes'], '.2%')"
          },
          "x": {"signal": "datum.x0 + 10"},
          "y": {"signal": "datum.y0 + 10"},
          "fontSize": {"scale": "fontsize", "field": "children"}
        }
      }
    },
    {
      "type": "text",
      "name": "text-leaves",
      "clip": true,
      "from": {"data": "leaves"},
      "interactive": true,
      "encode": {
        "enter": {
          "align": {"value": "left"},
          "baseline": {"value": "line-top"},
          "fill": {"value": "#FFF"},
          "opacity": {
            "value": 0.7
          }
        },
        "update": {
          "text": {
            "signal": "datum.courseName + ' ' + format(datum.total / data('total_leaves')[0]['total_leaves'], '.2%')"
          },
          "x": {"signal": "datum.x0 + 5"},
          "y": {"signal": "datum.y0 + 5"},
          "fontSize": {"scale": "fontsizeleaves", "field": "total"}
        }
      }
    }
  ]
};